import request from '@/utils/request'

// 1、获取不同状态任务列表
export function getWorkList(data) {
    return request({
      url: '/projectPackage/myJobList',
      method: 'post',
      data: data
    })
  }

// 2、取消报名
  export function cancelWork(data) {
    return request({
      url: '/apply/cancelApply',
      method: 'post',
      data: data
    })
  }

  // 3、任务包评价结果
  export function evaluateResult(data) {
    return request({
      url: '/workerEvaluate/evaluateResult',
      method: 'post',
      data: data
    })
  }

  // 4、附件下载
  export function zipDownload(adnId) {
    return request({
      url: '/attachment/zipDownload/'+adnId,
      method: 'get'
    })
  }


  // 5、删除已取消报名
  export function delWork(data) {
    return request({
      url: '/apply/deleteApply',
      method: 'post',
      data: data
    })
  }

  // 6、查询字典获取发包类型
  export function getPackageType() {
    return request({
      url: '/data/type/projectPackage_type',
      method: 'get',
    })
  }

  // 7、进行中---申请验收/查看验收---查看提交验收记录
  export function getCheckList(data) {
    return request({
      url: '/packageAccept/applyList',
      method: 'post',
      data: data
    })
  }

   // 8、进行中---申请验收---确定提交验收材料
   export function postCheckMaterial(data) {
    return request({
      url: '/packageAccept/apply',
      method: 'post',
      data: data
    })
  }

   // 9、进行中---申请验收---删除提交验收材料
   export function delCheckMaterial(data) {
    return request({
      url: '/packageAccept/remove',
      method: 'post',
      data: data
    })
  }

    // 10、进行中---申请验收---编辑提交验收材料
    export function editApply(data) {
      return request({
        url: '/packageAccept/editApply',
        method: 'post',
        data: data
      })
    }

  // 建模包 申请验收
  export function applyAccept(data) {
    return request({
      url: '/packageAccept/applyAccept',
      method: 'post',
      data: data
    })
  }


  // 撤回验收
  export function setpackageaccept(id) {
    return request({
      url: '/packageAccept/back/' + id,
      method: 'get',
    })
  }




// WEBPACK FOOTER //
// ./src/api/accept/myWork/index.js